import { MODALS } from "constants/modals"
// context
import { useModal } from "context/ModalContext/ModalContext"
import { useIdleTimer } from "react-idle-timer"
import useAuthenticationContext from "context/Authentication/useAuthenticationContext"
// utils

const InactivityChecker = () => {
  const { openModal, closeModal } = useModal()

  const { user } = useAuthenticationContext()

  if (!user?.id) {
    return null
  }

  const { getRemainingTime, activate } = useIdleTimer({
    timeout: 15 * 60 * 1000,
    promptBeforeIdle: 1 * 60 * 1000,
    onPrompt: () => {
      openModal(MODALS.AUTH.USER_INACTIVITY, {
        secondsLeft: Math.ceil(getRemainingTime() / 1000),
        closeModal,
        getRemainingTime,
        activate,
      })
    },
    throttle: 500,
  })

  return null
}

export default InactivityChecker
